import { render, staticRenderFns } from "./DiecutList.vue?vue&type=template&id=22852c68&scoped=true&"
import script from "./DiecutList.vue?vue&type=script&lang=ts&"
export * from "./DiecutList.vue?vue&type=script&lang=ts&"
import style0 from "./DiecutList.vue?vue&type=style&index=0&id=22852c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22852c68",
  null
  
)

export default component.exports